import React from 'react';
import expenseLockedReasons from '~/routes/app/expenses/expenseLockedReason';
import Tooltip from './Tooltip';
import LockIcon from './LockIcon';

function ExpenseLockIcon({ value, ...props }) {
  const locked = value !== 'unlocked';

  if (!locked) return null;

  const tooltip = expenseLockedReasons[value];

  return (
    <Tooltip message={tooltip}>
      <LockIcon {...props} />
    </Tooltip>
  );
}

export default ExpenseLockIcon;
